import { GET_MY } from "../../containers/App/constants";
import { STATS_DOMAIN, FETCH_STATS, FETCH_INSPECTION_STATS } from "./constants";

export function fetchStatsFor(tag_id, filter){
  return {
    type : GET_MY,
    work : STATS_DOMAIN,
    id : FETCH_STATS,
    tag_id,
    path : `stats/${tag_id}`,
    post : {
      filter
    }
  }
}

export function fetchInspectionStatistics(date) {
  return {
    type: GET_MY,
    work: STATS_DOMAIN,
    id: FETCH_INSPECTION_STATS,
    path: `statistics/inspections${date ? `?date=${date}` : ''}`,
  };
}
